import React from "react";
import EndPipes from '../components/EndPipes';
export default ({ isActive }) => {
  const message = 'Today Novartis is working with roughly 98,000 participants across 500 clinical trials.';
  return (
    <div className="component hide-overflow">
      <div style={{flexDirection: 'column'}} className="text-container">
        <p className="secondary-large centered">{message}</p>
      </div>
      {isActive && (<EndPipes />)}
    </div>
  );
};
